export const environment = {
  production: true,
  recaptchaKey: '6LcG-GMpAAAAAHsTtSAqZxz_3hrMqyfaBx0pxhO5',
  mapToken:
    'eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IjZZSDY2OUZYS1EifQ.eyJpc3MiOiJQQTk3WkZUREM5IiwiaWF0IjoxNzA5NDMyMjM1LCJleHAiOjE3MzU2MDMyMDAsIm9yaWdpbiI6Imh0dHBzOi8vcWEuYW1pZG1jbG9zY2Fib3MuY29tIn0.psZ8BIZvqtqfeQYjKEqvQxzeMhitY4hhPQiNAtT_dghSFqwHYntCpSaFN9elVpeJ-tcIu1FAty5-lebb_S2Mzg',
  apiUrl: 'http://api.amidmcloscabos.com/back',
  apiUrlAmi: 'https://api.amidmcloscabos.com/api',
};
